// src/utils/layout/prepareDocumentData.js
//
// Dokuman tipine gore veri hazirlama (switch-case extracted).

import { PROJECT_TYPES } from '../../../constants/projectTypes';
import {
  transformSimpleSupplyToYC_Data,
  transformSimpleSupplyToBranchCircuits,
  transformSimpleSupplyToVoltageDropData,
  transformSimpleSupplyToKabloBacasiData,
  expandSimpleSupplyForFloorCopies,
} from '../../../utils/simpleTransformFunctions';

export function prepareDocumentData(docDef, { simpleSupply, floorPlans, projectType, mainGrounding }) {
  switch (docDef.name) {
    case 'TekHat  \u015eemas\u0131': {
      // MULTI_METER: her grup kendi representative paneli üzerinden hesaplanır.
      // panelNames feeder içine enjekte edilir → createTekHatSema PanelNames() fonksiyonu kullanır.
      if (projectType === PROJECT_TYPES.MULTI_METER && docDef.tekHatRepresentativePanelId) {
        const data = transformSimpleSupplyToBranchCircuits(simpleSupply, docDef.tekHatRepresentativePanelId);
        if (data.feeder && docDef.tekHatGroupNames?.length > 0) {
          data.feeder = { ...data.feeder, panelNames: docDef.tekHatGroupNames };
        }
        return data;
      }
      return transformSimpleSupplyToBranchCircuits(simpleSupply);
    }
    case 'Kolon \u015eemas\u0131':
      if (projectType === PROJECT_TYPES.MULTI_FLOOR_SINGLE_METER) {
        const baseData = transformSimpleSupplyToBranchCircuits(simpleSupply);
        const ycData = transformSimpleSupplyToYC_Data(simpleSupply);
        const mainPanelOutputs = (ycData.panels || []).map((panel, i) => {
          const panelBranchData = transformSimpleSupplyToBranchCircuits(simpleSupply, panel.id);
          return {
            type: 'panel', name: panel.name || `N.K.T.-${i + 1}`,
            breaker: panel.panelMainBreaker || { curve: 'C', current: 40 },
            index: i, branchCircuits: panelBranchData.branchies || [], feeder: panelBranchData.feeder || null,
          };
        });
        return { ...baseData, mainPanelOutputs, adp: ycData.adp, panels: ycData.panels };
      }
      return transformSimpleSupplyToBranchCircuits(simpleSupply);
    case 'Pano Detay':
      return transformSimpleSupplyToBranchCircuits(simpleSupply);
    case 'Y\u00fckleme Cetveli':
      if (projectType === PROJECT_TYPES.MULTI_METER) {
        const expanded = expandSimpleSupplyForFloorCopies(simpleSupply, floorPlans);
        return transformSimpleSupplyToYC_Data(expanded);
      }
      return transformSimpleSupplyToYC_Data(simpleSupply);
    case 'Gerilim D\u00fc\u015f\u00fcm\u00fc': {
      const data = transformSimpleSupplyToVoltageDropData(simpleSupply);
      return data || {
        floorName: "Zemin Kat", startName: "\u015eebeke", startNode: "BOX",
        lengths: { enOda_KabBac: 3, kabBac_Daire: 4, kabBac: 5 }, circuits: [],
      };
    }
    case 'Topraklama Hesab\u0131': {
      const gd = simpleSupply.metadata?.grounding || {};
      return {
        soilResistivity: gd.soilResistivity || 100,
        area: mainGrounding?.area || gd.area || 10,
        strakeLength: gd.strakeLength || 2.5,
        stripLength: mainGrounding?.stripLength || gd.stripLength || 20,
        ul: gd.ul || 50,
        strakeCount: mainGrounding?.strakeCount || gd.strakeCount || 2,
      };
    }
    case 'Kablo Bacas\u0131':
      return transformSimpleSupplyToKabloBacasiData(simpleSupply, floorPlans);
    case 'Vaziyet Plan\u0131':
      return docDef.sitePlanId ? (docDef.objectsIds || []) : [];
    case 'Ground Floor':
    case 'Kat Plan\u0131':
      if (docDef.floorPlanId) {
        const plan = floorPlans.find(p => p.id === docDef.floorPlanId);
        return plan ? plan.objectsIds : [];
      }
      return [];
    default:
      return [];
  }
}
